<template>
  <svg
   xmlns:dc="http://purl.org/dc/elements/1.1/"
   xmlns:cc="http://creativecommons.org/ns#"
   xmlns:rdf="http://www.w3.org/1999/02/22-rdf-syntax-ns#"
   xmlns:svg="http://www.w3.org/2000/svg"
   xmlns="http://www.w3.org/2000/svg"
   xmlns:sodipodi="http://sodipodi.sourceforge.net/DTD/sodipodi-0.dtd"
   xmlns:inkscape="http://www.inkscape.org/namespaces/inkscape"
   inkscape:version="1.0rc1 (09960d6, 2020-04-09)"
   sodipodi:docname="tongue_N_triangle_4.svg"
   id="svg1118"
   version="1.1"
   viewBox="0 0 360 400"
   :height="height"
   :width="width">
  <defs
     id="defs1112">
      <filter id="blur">
         <feGaussianBlur in="SourceGraphic" stdDeviation="7,7" />
      </filter>
  </defs>
  <sodipodi:namedview
     inkscape:window-maximized="0"
     inkscape:window-y="23"
     inkscape:window-x="0"
     inkscape:window-height="755"
     inkscape:window-width="1252"
     scale-x="1"
     units="px"
     showgrid="false"
     inkscape:document-rotation="0"
     inkscape:current-layer="layer1"
     inkscape:document-units="px"
     inkscape:cy="187.25371"
     inkscape:cx="226.75885"
     inkscape:zoom="0.98994949"
     inkscape:pageshadow="2"
     inkscape:pageopacity="0.0"
     borderopacity="1.0"
     bordercolor="#666666"
     pagecolor="#ffffff"
     id="base" />
  <metadata
     id="metadata1115">
    <rdf:RDF>
      <cc:Work
         rdf:about="">
        <dc:format>image/svg+xml</dc:format>
        <dc:type
           rdf:resource="http://purl.org/dc/dcmitype/StillImage" />
        <dc:title></dc:title>
      </cc:Work>
    </rdf:RDF>
  </metadata>
    <path
       d="M 0.49804688 0.49804688 L 0.49804688 399.50195 L 359.50195 399.50195 L 359.50195 0.49804688 L 0.49804688 0.49804688 z M 233.96289 22.080078 C 247.52002 21.873251 260.90548 30.236107 277.40234 62.482422 C 321.97234 149.60316 281.48543 376.90158 179.61719 377.91992 C 76.730624 373.84657 38.567943 149.17576 82.785156 61.927734 C 117.03658 -5.6560941 143.67085 33.411903 182.42383 33.505859 C 203.01135 33.555773 218.59814 22.314482 233.96289 22.080078 z "
       style="fill:#ff000000;stroke:#ffffff;stroke-width:0.996347;stroke-opacity:1"
       id="outside" />
    <path
       id="mouth"
       style="fill:#280b0b;stroke:#000000;stroke-width:0.879489;stroke-opacity:1"
       d="M 180 8.7871094 A 112.69226 31.88006 0 0 0 67.308594 40.667969 A 112.69226 31.88006 0 0 0 86.068359 58.279297 C 118.85336 -2.0964101 144.91382 34.75285 182.40625 34.84375 C 219.8131 34.934442 240.5749 -2.535377 273.83203 58.322266 A 112.69226 31.88006 0 0 0 292.69141 40.667969 A 112.69226 31.88006 0 0 0 180 8.7871094 z " />
  <g id="cover_layer">
     <path
       style="display:inline;fill:none;stroke:#ff000000;stroke-width:1.90083px;stroke-linecap:butt;stroke-linejoin:miter;stroke-opacity:1"
       d="M 94.370716,58.449224 C 55.464487,135.21778 112.34002,336.48763 179.57222,336.48764 246.80443,336.48765 304.82777,135.59393 265.61112,58.937378 234.64493,-1.5920529 216.14014,33.523944 182.04182,33.441273 147.9435,33.358603 124.50814,-1.0170295 94.370716,58.449224 Z"
       id="cover"
       inkscape:connector-curvature="0"
       sodipodi:nodetypes="szsss" />
  </g>
  <g
     id="body_layer"
     inkscape:groupmode="layer"
     inkscape:label="Layer 1">
    <path
       style="display:inline;fill:#f59a9a;stroke:#ff000000;stroke-width:2.14295px;stroke-linecap:butt;stroke-linejoin:miter;stroke-opacity:1"
       d="M 83.566909,63.036211 C 39.704929,149.5833 103.82508,376.49026 179.62111,376.49027 255.41714,376.49028 320.83131,150.00736 276.61937,63.586545 241.70881,-4.652931 220.84693,34.936029 182.40528,34.842828 143.96363,34.749627 117.54315,-4.004663 83.566909,63.036211 Z"
       id="body"
       inkscape:connector-curvature="0"
       sodipodi:nodetypes="szsss" />
    <path
       id="lg"
       style="display:inline;fill:none;stroke:#000000;stroke-width:1;stroke-linecap:butt;stroke-linejoin:miter;stroke-miterlimit:4;stroke-dasharray:none;stroke-opacity:1"
       :style="{display: fragmented ? 'inline' : 'none'}"
       d="M 180.53516 280.74609 C 155.97078 280.68657 131.5434 288.02437 106.01367 303.71484 C 112.96039 318.59736 120.66554 331.96802 128.93555 343.06445 C 166.09041 331.25577 199.88436 331.92844 231.05273 342.35547 C 239.62693 330.80955 247.60793 316.87294 254.76758 301.35938 C 229.08789 288.02748 204.7386 280.80548 180.53516 280.74609 z " />
    <path
       id="he"
       style="display:inline;fill:none;stroke:#000000;stroke-width:1;stroke-linecap:butt;stroke-linejoin:miter;stroke-miterlimit:4;stroke-dasharray:none;stroke-opacity:1"
       :style="{display: fragmented ? 'inline' : 'none'}"
       d="M 183.31836 334.10742 C 165.92116 333.92101 147.73304 336.67146 128.66406 342.69336 C 142.40446 361.24036 157.70229 373.52493 173.64453 376.01367 C 175.40408 376.23528 177.18454 376.38746 178.98438 376.47461 C 179.1968 376.47817 179.40848 376.49023 179.62109 376.49023 C 197.8333 376.49024 215.43949 363.39095 231.07617 342.32422 C 215.8152 337.14091 199.92698 334.28539 183.31836 334.10742 z " />
    <path
       d="M 233.52973,23.509006 C 218.28841,23.741527 202.82685,34.892503 182.40473,34.84299 143.96308,34.74979 117.54307,-4.004525 83.566828,63.036349 79.939772,70.193153 76.883083,78.298077 74.363707,87.118381 157.10735,102.14131 223.40255,97.042159 285.67035,87.012912 283.1908,78.431089 280.18304,70.552635 276.61957,63.587131 260.25524,31.599876 246.97794,23.30384 233.52973,23.509006 Z"
       style="display:inline;fill:none;stroke:#000000;stroke-width:1;stroke-linecap:butt;stroke-linejoin:miter;stroke-miterlimit:4;stroke-dasharray:none;stroke-opacity:1"
       :style="{display: fragmented ? 'inline' : 'none'}"
       id="k-bl-li"
       inkscape:connector-curvature="0" />
    <path
       id="lv-gb-l"
       style="display:inline;fill:none;stroke:#000000;stroke-width:1;stroke-linecap:butt;stroke-linejoin:miter;stroke-miterlimit:4;stroke-dasharray:none;stroke-opacity:1"
       :style="{display: fragmented ? 'inline' : 'none'}"
       d="M 285.29883 87.375 L 247.07227 92.550781 C 260.8279 168.77627 256.90205 231.5444 246.04297 296.83008 L 254.68555 301.53711 C 284.43681 237.17848 300.04919 145.81721 285.29883 87.375 z " />
    <path
       id="lv-gb-r"
       style="display:inline;fill:none;stroke:#000000;stroke-width:1;stroke-linecap:butt;stroke-linejoin:miter;stroke-miterlimit:4;stroke-dasharray:none;stroke-opacity:1"
       :style="{display: fragmented ? 'inline' : 'none'}"
       d="M 74.804688 87.427734 C 60.193171 146.61078 75.91986 239.07447 105.88867 303.44336 L 113.45508 298.65039 C 103.3286 229.15936 100.21634 165.15358 112 92.923828 L 74.804688 87.427734 z " />
    <path
       id="st-sp"
       style="display:inline;fill:none;stroke:#000000;stroke-width:0.769456;stroke-linecap:butt;stroke-linejoin:miter;stroke-miterlimit:4;stroke-dasharray:none;stroke-opacity:1"
       :style="{display: fragmented ? 'inline' : 'none'}"
       d="M 113.45814,298.65084 C 103.33166,229.1599 100.21912,165.15116 112.00278,92.9214 c 49.8885,5.559577 93.82198,4.169466 135.07476,-0.346263 13.74955,76.212793 9.82392,138.976643 -1.03377,204.254303 -50.69744,-23.09934 -86.29482,-20.59643 -132.58563,1.82109 z"
       inkscape:connector-curvature="0"
       sodipodi:nodetypes="cccccc" />
  </g>
</svg>
</template>

<script>
export default {
   props: {
      fragmented: {
         default: false
      },
      height: {
         default: 400
      },
      width: {
         default: 360
      }
   },
	mounted() {
		this.$emit('mounted');
	}
}
</script>